import React from "react";
import './BottomMenu.css';

interface IBottomMenuProps{
    bottomMenu: string[],
    selectedBottomMenuTabIndex: number,
    setSelectedBottomMenuTabIndex: (index: number)=>void;
}

export const BottomMenu = ({bottomMenu, selectedBottomMenuTabIndex, setSelectedBottomMenuTabIndex}: IBottomMenuProps)=>{
    return (
        <div className="bottomMenu">
            {bottomMenu.map((tab, index)=>(
                <div className={`button bottomMenu_button ${index == selectedBottomMenuTabIndex ? 'bottomMenu_button--active' : ''}`}
                    onClick={()=>setSelectedBottomMenuTabIndex(index)}>
                    {tab}
                </div>  
            ))}
        </div>
    )
}